import React from 'react';
import { useDeleteMasterMedicine } from '../../../../apis/master-medicines/hooks/useDeleteMasterMedicine';
import { DangerButton } from '../../../../healtheraComponents';
import { useHistory } from 'react-router';
import { enqueueSnackbar } from 'notistack';

interface DeleteMasterMedicineProps {
  id: string;
}

const DeleteMasterMedicine = ({ id }: DeleteMasterMedicineProps) => {
  const { deleteMasterMedicine, isLoading } = useDeleteMasterMedicine();
  const history = useHistory();

  const handleDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete this master medicine?');

    if (shouldDelete) {
      await deleteMasterMedicine(id);
      enqueueSnackbar('Master medicine deleted', { variant: 'success' });
      history.goBack();
    }
  };

  return (
    <DangerButton disabled={isLoading} onClick={handleDelete}>
      Delete
    </DangerButton>
  );
};

export default DeleteMasterMedicine;
